module.exports = {
  pleaseWait:'කරුණාකර රැඳී සිටින්න',
  loading:'ලෝඩ් වෙමින් පවතී',
  Billing:'බිල්පත්',
  billingTips:'ඔබගේ මිලදී ගැනීම් ඉතිහාසය',
  ID:'හැඳුනුම් අංකය',
  FAQ:'නිතර අසන ප්‍රශ්න',
  TC:'නියමයන් සහ කොන්දේසි',
  Copyright:'© 2026 සියලු හිමිකම් ඇවිරිණි..',
  GenerateImage:'රූපය ජනනය කරන්න',
  generateTips1:'අපගේ AI රූප ජනකය ඔබගේ කල්පනාව ජීවමාන කරමින් තත්පර කිහිපයකින් අලංකාර චිත්‍ර, නිර්මාණ සහ ඡායාරූප නිපදවයි. AI බලයෙන් නව ආකාරවලින් ඔබගේ සෘජුකරණය ප්‍රකාශ කරන්න. අලෙවිකරණ ද්‍රව්‍ය නිර්මාණය කිරීමෙන් ආකර්ෂණීය කලා කෘති සෑදීම දක්වා අසීමිත හැකියාවන් සොයා බලන්න.',
  generateTips2:'පහතින් වචන කිහිපයක් ඇතුළත් කරන්න, Snapai ඔබගේ පෙළ විශ්මිත කලාකෘතියක් බවට පරිවර්තනය කරන ආකාරය නරඹන්න.',
  Prompt:'විස්තරය',
  PromptTips1:'AIට ඇඳිය යුතු දේ කියන්න.',
  PromptTips2:'උපදෙස්: මනෝභාවය සහ ආලෝකය විස්තර කරන්න. වැඩිදුර ඉඟි සඳහා පිටුව බලන්න.',
  PromptTips3:'Note: සටහන: AI උපදෙස් සම්පූර්ණයෙන්ම අනුගමනය නොකළ හැකි අතර ගණන් කිරීමේ හැකියාව සීමිත වේ.',
  Generate:'Generate',
  ChancesLeft:'ඉතිරි අවස්ථා',
  BuyChances:'තවත් අවස්ථා මිලදී ගන්න',
  generateImageTips1:'ඔබට අවශ්‍ය දේ ඇතුළත් කරන්න',
  generatePromptsTips1:'ඔබට අවශ්‍ය නොවන දේ ඇතුළත් කරන්න',
  indexTips1:"දෛනික නොමිලේ අවස්ථාව <br/> ලබා ගත හැක!",
  indexTips2:'මෙවලින් එකක් තෝරන්න',
  ImageRestorer:'රූප ප්‍රතිසාධකය',
  Continue:'ඉදිරියට',
  language0:'භාෂාව',
  language:'භාෂාව තෝරන්න',
  languageTips:'මෙහි ඔබගේ භාෂාව තෝරන්න',
  Submit:'යොමු කරන්න',
  change:'වෙනස් කරන්න',
  English:'ඉංග්‍රීසි',
  Myanmar:'සිංහල',
  Login:'පිවිසෙන්න',
  Logout:'පිටවන්න',
  getCode:'යවන්න',
  loginTips:'දුරකථන අංකය ඇතුළත් කරන්න',
  profile:'පැතිකඩ',
  phoneNumber:'දුරකථන අංකය',
  SubscribedSince:'දායකත්වය ආරම්භ වූ දිනය',
  RemainingChances:'ඉතිරි අවස්ථා',
  cgtips2:'දිනකට 149ks පමණි,<br />දායක වීමට OK ඔබන්න.',
  cgtips2W:'සතිකට 599ks පමණි,<br />දායක වීමට OK ඔබන්න.',
  cgtips2M:'මාසකට 1999ks පමණි,<br />දායක වීමට OK ඔබන්න.',
  OK:'හරි',
  PictureRestorer:'පින්තූර ප්‍රතිසාධකය',
  PictureTips1:'AI භාවිතයෙන් පින්තූර ප්‍රතිසාධනය කිරීම, තීක්ෂණ කිරීම සහ අලුත්වැඩියා කිරීම සිදු කරන්න. Snapai නවතම පර්යේෂණ මත පදනම්ව ස්වයංක්‍රීයව සීරුමාරු ඉවත් කරමින්, වර්ණ පැහැදිලි කරමින් සහ මුහුණු උසස් කරමින්, හානි වූ ඡායාරූප මතකයන් බවට පරිවර්තනය කරයි. අපගේ නොමිලේ සේවාව වර්ණ සහ කළු-සුදු ඡායාරූප දෙකම අලුත්වැඩියා කරයි.',
  Upload:'උඩුගත කරන්න',
  PictureTips2:'සීරුමාරු තිබේද?',
  Restore:'ප්‍රතිසාධනය කරන්න',
  uploadTips:'කරුණාකර පින්තූර උඩුගත කරන්න',
  PurchaseChances:'අවස්ථා මිලදී ගන්න',
  History:'ඉතිහාසය',
  purchaseTips1:'ඔබේ සමස්ත අවස්ථා',
  purchaseTips2:'එකවර මිලදී ගැනීම',
  Daily:'දිනපතා',
  Weekly:'සතිපතා',
  OneTime:'එකවර',
  Purchase:'මිලදී ගන්න',
  DailyKyats:'169 Ks',
  WeeklyKyats:'699 Ks',
  OneTimeChance:'අවස්ථාවක් සඳහා 149 Ks',
  Subscribe:'දායක වන්න',
  purchaseTips3:'කරුණාකර ඔබට මිලදී ගැනීමට අවශ්‍ය <strong>අවස්ථා</strong> සංඛ්‍යාව තෝරන්න.',
  BuyNow:'දැන් මිලදී ගන්න',
  logout:'පිටවන්න',
  petTitle1:'AI සත්ත්ව පූසානු',
  petTitle2:'ශෛලිය තෝරන්න',
  petContent1:' ඔබේ ආදරණීය සත්ත්වයාගේ ඡායාරූපය විහිළු සහිත, ඇනිමේ ශෛලියේ කෘතියක් බවට පරිවර්තනය කරයි. සත්ත්ව ආදරවන්තයින් සහ ඇනිමේ ආසකරුවන් සඳහා විශිෂ්ට වේ, Snapai ඔබේ සත්ත්ව මිතුරන් සමරන්න පුද්ගලික සහ විනෝදමය ආකාරයක් ලබා දෙයි.',
  sexTitle1:'AI පුද්ගලික ඇනිමේ',
  sexTitle2:'ලිංගය තෝරන්න',
  sexContent1:'ලිඛිත ඉඟි මත ඇනිමේ ශෛලියේ ඡායාරූප ජනනය කර ඔබේ කල්පනාව ජීවමාන කරයි. ඔබ ඇනිමේ ආසකරුවෙක්, කථාකරුවෙක්, හෝ නිර්මාණශීලියෙක් වුවද, AI ඇනිමේ ඡායාරූපය ඔබට උසස් තත්ත්වයේ, සජීවී ඇනිමේ විස්තර නිර්මාණය කිරීමට හැකියාව ලබා දෙයි, නව්‍ය AI සහ ඔබේ අද්විතීය දැක්ම එකතු කරමින්.',
  sexContent2:'පහත ලිංගය තෝරන්න සහ පහත විස්තර ඇතුළත් කරන්න. Snapai පෙළ අද්භූත කලාකෘතියක් බවට පරිවර්තනය කරන ආකාරය නරඹන්න.',
  Female:'ස්ත්‍රී',
  Male:'පුරුෂ',
  Style1:'ශෛලිය 1',
  Style2:'ශෛලිය 2',
  Style3:'ශෛලිය 3',
  Comic:'කොමික',
  Disney:'ඩිස්නි',
  Ghibli:'ගිබ්ලි',
  Animalanime:'සෙල්ෆි ඇනිමේ',
  HumanAnime:'මානව ඇනිමේ',
  Guidance:'මඟපෙන්වීම',
  PetAnime:'සත්ත්ව ඇනිමේ',
  landTips1:'අද්භූත ඡායාරූප නිර්මාණය &',
  landTips2:'විශාල ත්‍යාග ජයගන්න!',
  landTips3:'SnapAI සමඟ ඔබේ කල්පනාව සැබෑ බවට පරිවර්තනය කරන්න! අද්භූත ඡායාරූප ජනනය කිරීමෙන් කලාත්මක කෘති දක්වා SnapAI ඔබට අසීමිත හැකියාවන් ලබා දෙයි. සීමාවක් නැති සොඳුරු ලෝකයක් අත්විඳින්න.',
  show401tip:'ශේෂය ප්‍රමාණවත් නොවේ',
  show400dailytip:'කාලය අවසන්. විශාල ත්‍යාග ජය ගැනීමට "ON1" 548 ට යවන්න.',
  show400weeklytip:'කාලය අවසන්. විශාල ත්‍යාග ජය ගැනීමට "ON7" 548 ට යවන්න.',
  register:'ලියාපදිංචි වන්න',
  invitation:'ආරාධනාව',
  invitationTips:'පහත සබැඳිය පිටපත් කර එවන්න',
  InviteNow:'දැන් ආරාධනා කරන්න',
  copySuccess:'පිටපත් කිරීම සාර්ථකයි!',
  process:'ජනනය වෙමින් පවතී',
  downTips1:'කරුණාකර සබැඳිය බ්‍රව්සරයට පිටපත් කර බාගත කරන්න.',
  copyLink:'සබැඳිය පිටපත් කරන්න',
  free:'නොමිලේ',
  aiAnimeTitle:'AI යුගල ඇනිමේ',
  aiAnimeCt1:'ඔබේ මුල් යුගල ඡායාරූප ඇනිමේ ශෛලියේ පින්තූර බවට පරිවර්තනය කර, රොමැන්තික මතක වඩා විනෝදජනක කරන්න. ඇනිමේ ආසකරුවෙක් වුවද, නිර්මාණශීලියෙක් වුවද, AI ඇනිමේ ඡායාරූපය ඔබට උසස් තත්ත්වයේ, අරුත්පූර්ණ ඇනිමේ විස්තර නිර්මාණය කිරීමට ඉඩ සලසයි.',
  aiAnimeCt2:'පහත ශෛලිය තෝරන්න සහ ඔබේ මුල් ඡායාරූපය උඩුගත කරන්න. Snapai ඔබේ මිහිරි මතක අද්භූත කලාකෘති බවට පරිවර්තනය කරන ආකාරය නරඹන්න.',
  comingsoonT:'ලඟදි එනවා',
  SubscribePackage:'දායකත්ව පැකේජය',
  landfont1:'පින්තූර ඇනිමේ ශෛලියේ කලාකෘතියක් බවට පරිවර්තනය කරන්න.',
  landfont2:'ඔබේ යුගල ඡායාරූප සොඳුරු ඇනිමේ චරිත බවට පරිවර්තනය කරන්න.',
  landfont3:'අලංකාර පින්තූර ජනනය කිරීමට විස්තරයක් ලියන්න.',
  landfont4:'ඔබේ සත්ත්වයන් AI මායා ශක්තියෙන් අලංකාර ඇනිමේ චරිත බවට පරිවර්තනය කරන්න!',
  landfont5:'AI බලයෙන් පින්තූර ප්‍රතිසාධනය සමඟ ඔබේ මතක නැවත සොයා බලන්න.',
  SmartCutout:'ස්මාර්ට් කට්අවුට්',
  letgo:'ඉදිරියට යමු',
  IpIMage:'හැඳුනුම් ඡායාරූප',
  IpIMageTip:'ලයිසන්ස් හෝ හැඳුනුම් ඡායාරූපයක් අවශ්‍යද? අපි ඔබ සඳහා සූදානම්!',
  IpIMage_content:'හැඳුනුම් ඡායාරූප සඳහා උඩුගත කරන මුල් රූපය පුද්ගලයාගේ මුහුණ පැහැදිලිව, බාධා රහිතව සහ කන්ඩායම් සමාන්තරව තිබීම වගකිය යුතුය. එසේ නොමැතිනම් ජනනය අසාර්ථක විය හැක. ',
  snapbot:'SnapBot',
  snapbot_hi:'හයි, මම SnapBot.',
  help_today:'අද මම ඔබට කෙසේ උදව් කළ හැකිද?',
  think_ip:'🤖 සිතමින්...',
  Coloring_old_photos:'පින්තූර නැවත වර්ණ කිරීම',
  Coloring_old_photos_tips:'ඔබේ පැරණි ඡායාරූප වලට වර්ණය නැවත ලබා දී මතක නැවත ජීවිතයට එළිය කරන්න. අපගේ AI මෙවලම ස්වයංක්‍රීයව වර්ණ විශ්ලේෂණය කර ස්වාභාවික වර්ණ ස්වරූප එක් කරයි, මුල් රූපයේ ආකර්ෂණය රැකගෙන දර්ශනීයත්වය වැඩි කරයි.',
  Coloring_old_photos_tips2:' AI බලයෙන් පැරණි ඡායාරූප නැවත වර්ණයෙන් සජීවී කරන්න.',
  BgFusion:'ස්මාර්ට් බ්ලෙන්ඩ්',
  BgFusion_tips2:'ඔබේ ඡායාරූපය කැමති පසුබැසීම සමඟ අභිරුචි කරගන්න',
  BgFusion_tips:'ඔබේ ඡායාරූපය කැමති පසුබැසීම සමඟ අභිරුචි කරන්න.\n' +
    'අපගේ ස්මාර්ට් AI මුල් පසුබැසීම වෙනස් කර ඔබේ රූපය ස්වභාවිකව නව \n' +
    'දර්ශනයට ඒකාබද්ධ කරයි.',
  Upload_bg:'පසුබැසීම උඩුගත කරන්න',
  Upload_pt:'පෝර්ට්‍රේට් උඩුගත කරන්න',
  Recolor:'නැවත වර්ණ කරන්න',
  snapbotTips1:'වේගවත් සෙවීම් ප්‍රතිඵල',
  snapbotTips2:'ස්වභාවික භාෂා සැකසුම',
  snapbotTips3:'විශාල දත්ත විශ්ලේෂණය',
  snapbotTips4:'AI බලයෙන් ක්‍රමලේඛ',
  snapbotInput1:'SnapBot සමඟ ආරම්භ කිරීමට මෙතන ටැප් කරන්න',
  white:'සුදු',
  blue:'නිල්',
  '1 inch':'1 අඟල්',
  '2 inches':'2 අඟල්',
  '3 inches':'3 අඟල්',
  landTips11:'ඡායාරූප නිර්මාණය &',
  ChangeHairstyle:'කෙස් පැහැදිලි කිරීමේ මායා',
  ChangeHairstyle_short:'ඔබේ කල්පිත කොණ්ඩය නිර්මාණය සහ උත්සාහ කරන්න',
  ChangeHairstyle_content_1:'Snapai යෙදුම කෙස් පැහැදිලි කිරීමේ විශේෂාංගයක් ලබා දෙයි, පරිශීලකයින්ට වර්තමාන හෝ උඩුගත කරන ලද ඡායාරූප මගින් විවිධ කොණ්ඩ ආකාර උත්සාහ කිරීමට ඉඩ සලසයි. AI තාක්ෂණය මඟින් පරිශීලකයාගේ මුහුණේ රූප විශේෂාංග විශ්ලේෂණය කර සුදුසු කොණ්ඩ ආකාර උපදෙස් ලබා දෙයි. සුළු වෙනස්කම් සිට දැඩි විචිත්‍රාත්මක වෙනස්කම් දක්වා විවිධ රූප පරීක්ෂා කර පුද්ගලික අත්දැකීම ලබා දෙයි.',
  ChangeHairstyle_content_2:'පහත ඔබ කැමති කොණ්ඩ ආකාරය තෝරන්න සහ ඔබේ ඡායාරූපය එක් කරන්න. ඔබට අලංකාර සහ පැහැදිලි රූපයක් ලැබේ.',
  Result:'ප්‍රතිඵල',
  Original:'මුල්',
  unsub_tip:'දායකත්වය අත්හැරීමට OFF 548 ට යවන්න',
  sub_tip:'දායකත්වය සඳහා "ON1" හෝ "ON7" 548 ට යවන්න',
  longHairEffects:'දිග කොණ්ඩ බලපෑම',
  longHairEffects_tip:'දිග කොණ්ඩ බලපෑම උත්සාහ කරන්න. මෙය ස්වාභාවික සහ ආකර්ෂණීය කොණ්ඩ ආකාරයක් ලබා දෙයි. මෘදු සහ දියුණු, ස්වාභාවික දිග, ඕනෑම ඇඳුමක් සඳහා සුදුසුයි!',
  VIDEO:'වීඩියෝ',
  image_video:'පින්තූරයෙන් වීඩියෝ',
  image_video_tip:'මෙම විශේෂාංගය නිශ්චල ඡායාරූපයක් සජීවී 1–3 මිනිත්තු ඇනිමේට් වීඩියෝවක් බවට පරිවර්තනය කරයි. මුහුණු ස්වභාවික ප්‍රකාශ සහ චලනය එක් කර රූපය ජීවිතවත් වේ. පරිශීලකයින්ට මීට පෙර ජනනය කරන ලද වීඩියෝ ඉතිහාසයෙන් බලන්න පුළුවන්.',
  word_video:'පෙළෙන් වීඩියෝ',
  word_video_tip:'මෙම විශේෂාංගය ඔබ ලිවූ පෙළ AI තාක්ෂණය භාවිතයෙන් සජීවී වීඩියෝවක් බවට පරිවර්තනය කරයි. ඔබේ කැමති ශෛලිය සහ ප්‍රකාශය දැක්විය හැක. ජනනය 1–3 මිනිත්තු ගත විය හැක, පෙර නිර්මාණ වීඩියෝ ඉතිහාසයෙන් බලන්න පුළුවන්.',
  word_video_input:"ඔබට අවශ්‍ය වීඩියෝවගේ ශෛලිය සහ ආකාරය විස්තර කරන්න.",
  image_video_input:"ඔබට අවශ්‍ය පින්තූරයේ ශෛලිය සහ ආකාරය විස්තර කරන්න.",
  aiDressUp:"AI ඇඳුම් සැකසීම",
  aiDressUp_tip:"AI Dress Up සමඟ, ඔබේ රූපය උඩුගත කර අසීමිත ඇඳුම් උත්සාහ කරන්න—සම්ප්‍රදායික, නිල, හෝ නවීන. SnapAI ඇඳුම් ස්වභාවිකව ඔබේ ශරීරයට ගැලපෙන බව සහතික කරයි.",
  singleheart:"ආදර බලපෑම",
  singleheart_desc:"ඔබේ ආදරය හුවමාරු කරන්න! ඔබේ වීඩියෝවට මිහිරි හදවත ආකාරයේ බලපෑම එක් කරන්න.",
  aiVividScene:"සජීවී AI දර්ශනය",
  aiVividScene_desc:"නව AI Scene Creator සමඟ සියලුම කාලගුණ සහ මනෝභාව සඳහා නිර්මාණශීලී ඡායාරූප ගන්න. පැහැදිලි මුහුණේ ඡායාරූපයක් ඇති විට, විවිධ පසුබැසි, ශෛලියන් සහ වර්ණ තේමාවන් තෝරා අද්භූත ඡායාරූප ජනනය කරන්න.",
  pic_size_limit :"ඡායාරූප 5MB ඉක්මවා නොහැක",
  spin_tip_1 :"ඔබේ අවස්ථාව අහිමි නොකරන්න!",
  spin_tip_2 :"Spin වීල් දෛනික කාර්ය මාර්ගය තුළ පමණක් ලබා දේ",
  close :"වසන්න",
  spin:'Spin',
  SpinChances:'Spin අවස්ථා',
  date:'දිනය',
  Prizes:'ත්‍යාග',
  nochance:'ඔබට ප්‍රමාණවත් අවස්ථා නොමැත',
  WinnerList:'ජයග්‍රාහක ලැයිස්තුව',
  Congratulations:"සුභපැතුම්! ඔබ ජයගත්තා",
  Confirm:"තහවුරු කරන්න",
  spinTips2:'දෛනික නොමිලේ Spin!',
  spinTips3:'ඔබේ නොමිලේ Lucky Spin ටෝකන් ලබා ඔබේ වාසනාව අදම උත්සාහ කරන්න!',
  spinTips4:'මගේ ටෝකන් ලබා ගන්න',
  No:'නැහැ',
  not_win:"ක්‍රීඩා කිරීම සඳහා ස්තුතියි. ඊළඟ වරට වාසනාව ලැබේවා!",
  win_tip:'ඔබේ ත්‍යාගය ලබා ගැනීමට පහත ටැප් කරන්න',
  unsubscribe:'දායකත්වයෙන් ඉවත් වන්න',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js